(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["1-anchor-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {

  function initAnchorTabs() {

    document.querySelectorAll('[data-anchor-tabs]').forEach(function(root) {

      if (root.dataset.anchorTabsReady === 'true') return;

      var tabs = Array.prototype.slice.call(
        root.querySelectorAll('[data-anchor-tab]')
      );

      if (!tabs.length) return;

      root.dataset.anchorTabsReady = 'true';


      /* -----------------------------
       * Helpers
       * ----------------------------- */

      function getSectionTargets(tab) {

        return [
          tab.getAttribute('data-first-section'),
          tab.getAttribute('data-second-section'),
          tab.getAttribute('data-third-section')
        ].filter(function(value) {
          return value && value.trim() !== '';
        });

      }


      function hideSections(tab) {

        getSectionTargets(tab).forEach(function(selector) {

          try {

            var target = document.querySelector(selector);

            if (target) {
              target.style.display = 'none';
            }

          } catch(e) {

            console.warn(
              'Anchor Tabs: invalid selector',
              selector
            );

          }

        });

      }


      function showSections(tab) {

        getSectionTargets(tab).forEach(function(selector) {

          try {

            var target = document.querySelector(selector);

            if (target) {
              target.style.display = 'block';
            }

          } catch(e) {

            console.warn(
              'Anchor Tabs: invalid selector',
              selector
            );

          }

        });

      }


      function hideBlocks(tab) {

        var blockId =
          tab.getAttribute('data-block-id');

        if (!blockId) return;


        document.querySelectorAll(
          '.star_product_block[data-block-id="' +
          blockId +
          '"]'
        ).forEach(function(element) {

          element.style.display = 'none';

        });


        document.querySelectorAll(
          '.view_more_wrapper[data-block-id="' +
          blockId +
          '"]'
        ).forEach(function(element) {

          element.style.display = 'none';

        });

      }


      function showBlocks(tab) {

        var blockId =
          tab.getAttribute('data-block-id');

        if (!blockId) return;


        var blocks = document.querySelectorAll(
          '.star_product_block[data-block-id="' +
          blockId +
          '"]'
        );


        blocks.forEach(function(element, index) {

          var parent = element.closest(
            '.star-page-product-multiple-tab-section'
          );


          if (!parent) {

            element.style.display = 'flex';

            return;

          }


          var desktopCount =
            parseInt(
              parent.getAttribute(
                'data-products-count'
              ),
              10
            ) || blocks.length;


          var mobileCount =
            parseInt(
              parent.getAttribute(
                'data-products-count-m'
              ),
              10
            ) || blocks.length;


          if (window.innerWidth < 750) {

            element.style.display =
              index < mobileCount
                ? 'flex'
                : 'none';

          } else {

            element.style.display =
              index < desktopCount
                ? 'flex'
                : 'none';

          }

        });


        var viewMore =
          document.querySelector(
            '.view_more_wrapper[data-block-id="' +
            blockId +
            '"]'
          );


        if (viewMore) {

          if (window.innerWidth < 750) {

            if (
              !viewMore.classList.contains(
                'hideMobile'
              )
            ) {
              viewMore.style.display = 'flex';
            }

          } else {

            if (
              !viewMore.classList.contains(
                'hideDesktop'
              )
            ) {
              viewMore.style.display = 'flex';
            }

          }

        }

      }


      function hideContent(tab) {

        var linkedTo =
          tab.getAttribute('data-linked-to');


        if (linkedTo === 'blocks') {

          hideBlocks(tab);

        } else {

          hideSections(tab);

        }

      }


      function showContent(tab) {

        var linkedTo =
          tab.getAttribute('data-linked-to');


        if (linkedTo === 'blocks') {

          showBlocks(tab);

        } else {

          showSections(tab);

        }

      }


      /* -----------------------------
       * Make sure only ONE tab active
       * ----------------------------- */

      var activeTabs =
        tabs.filter(function(tab) {

          return tab.classList.contains('active');

        });


      var initialTab =
        activeTabs.length
          ? activeTabs[0]
          : tabs[0];


      tabs.forEach(function(tab) {

        if (tab === initialTab) {

          tab.classList.add('active');

        } else {

          tab.classList.remove('active');

        }

      });


      /* -----------------------------
       * INITIAL STATE
       *
       * Important:
       * only hide NON-active content.
       *
       * Active content remains untouched.
       * ----------------------------- */

      tabs.forEach(function(tab) {

        if (tab !== initialTab) {

          hideContent(tab);

        }

      });


      /* -----------------------------
       * Click
       * ----------------------------- */

      tabs.forEach(function(tab) {

        tab.addEventListener(
          'click',
          function() {

            if (
              tab.classList.contains('active')
            ) {
              return;
            }


            var currentActive =
              root.querySelector(
                '[data-anchor-tab].active'
              );


            /* Hide current active content */

            if (currentActive) {

              hideContent(currentActive);

              currentActive.classList.remove(
                'active'
              );

            }


            /* Activate new tab */

            tab.classList.add('active');


            /* Show ONLY new tab content */

            showContent(tab);


            /* Product card alignment */

            if (
              typeof alignProductTitleRow ===
              'function'
            ) {

              setTimeout(function() {

                alignProductTitleRow();

              }, 50);

            }

          }
        );

      });

    });

  }


  /* Normal storefront */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAnchorTabs
    );

  } else {

    initAnchorTabs();

  }


  /* Shopify theme editor reload */

  document.addEventListener(
    'shopify:section:load',
    function() {

      initAnchorTabs();

    }
  );

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accessories-showcase"] && !Shopify.designMode) return;
  try {
    
    if(document.querySelectorAll('.accessories-tab-title').length > 0){
      document.querySelectorAll('.accessories-tab-title').forEach(function(tabTitle){
        tabTitle.onclick = function(evt){
          var tabHandle = evt.target.getAttribute('data-tab-title');
          document.querySelectorAll('.accessories-tab-title').forEach(function(tabTitleTemp){
            tabTitleTemp.classList.remove('tab-active');
          });
          evt.target.classList.add('tab-active');
          document.querySelectorAll('.accessories-tab-content').forEach(function(tabContentTemp){
            tabContentTemp.classList.remove('tab-content-active');
          });
          document.querySelector('.accessories-tab-content[data-tab-title='+tabHandle+']').classList.add('tab-content-active');
        }
      });
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-blocks"] && !Shopify.designMode) return;
  try {
    
      const blocks = document.querySelectorAll('.campaign-block');
      blocks.forEach(block => {
        if(block.querySelector('.question-icon')){
            let element = block.querySelector('.question-icon');
            const infoBox = block.querySelector('.campaign_info');
            if(window.innerWidth < 750){
                element.onclick = function(){
                    document.querySelectorAll('.campaign_info').forEach(function(info){
                if(info != infoBox){
                  if(info.classList.contains('open')){ info.classList.remove('open'); info.style.display = 'none'; }
                }
              });
              if(infoBox.classList.contains('open')){
                infoBox.style.display = 'none';
                infoBox.classList.remove('open');
              } else {
                infoBox.style.display = 'block';
                infoBox.classList.add('open');
              }
            }
          }
          else{
            element.onmouseover = function(){
              infoBox.style.display = 'block';
            }
            element.onmouseout = function(){
              infoBox.style.display = 'none';
            }
          }
        }
      });

      document.addEventListener('click', function(e){
        let el = e.target;
        if(!el.classList.contains('question-icon')) {
          if(document.querySelector('.campaign_info.open')){
            document.querySelector('.campaign_info.open').style.display = 'none';
            document.querySelector('.campaign_info.open').classList.remove('open');
          }
        }
      });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_animated-media"] && !Shopify.designMode) return;
  try {
    
  class ScrollSlider extends window.HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector("[data-config]");
      this.config = this.slider.dataset.config;
      this.speed = Number(this.slider.dataset.speed) || 60;
      this.sliderItems = this.querySelectorAll(".tm-item");
      this.sliderWidth = 0;

      // Calculate total width of slider items
      this.sliderItems.forEach(item => {
        this.sliderWidth += item.clientWidth;
      });

      this.sliderWidth = this.clientWidth - this.sliderWidth;
      // Initialize GSAP timeline
      this.tm = gsap.timeline();
      this.init();
    }

    init() {
      this.tm.to(this.slider, {
        x: "-100%",
        duration: this.speed,
        ease: "power1.in", // GSAP easing function
        repeat: -1,
        modifiers: {
          x: gsap.utils.unitize(t => parseFloat(t) % window.innerWidth) // use gsap.utils
        },
        onComplete: () => {
          const rect = this.getBoundingClientRect();
          console.log(rect);
        }
      });

      this.addEventListener("mouseenter", () => {
        this.tm.pause();
      });

      this.addEventListener("mouseleave", () => {
        this.tm.play();
      });
    }

    // New method to update speed
    setSpeed(newSpeed) {
      this.speed = newSpeed;
      this.tm.timeScale(newSpeed / 60); // Adjust the timeline speed
    }

    // New method to reset the slider
    resetSlider() {
      this.tm.restart();
    }
  }

  // Define the custom element
  if (!window.customElements.get("scroll-slider")) {
    window.customElements.define("scroll-slider", ScrollSlider);
  }


  document.addEventListener("DOMContentLoaded", function() {
    // Initialize the tooltip

    // Add event listener for window resize
    window.addEventListener("resize", function() {
      // Re-initialize the tooltip on resize
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_benefit-box-content"] && !Shopify.designMode) return;
  try {
    
  function initTooltip() {
    const tooltip = document.querySelectorAll('[data-js-tooltip]');
    const tooltipMobile = document.querySelectorAll('[data-js-tooltip-mobile]');
    let tooltipVisible = false; // Flag to track tooltip visibility

    if (tooltip || tooltipMobile) {
      // Use click event for mobile
      tooltipMobile.forEach(function(tooltip) {
        tooltip.addEventListener('click', function() {
          console.log('click');
          const content = tooltip.closest('[data-js-tooltip-container]').querySelector('[data-js-tooltip-content]');
          tooltipVisible = !tooltipVisible; // Toggle the flag
          content.classList.toggle('cust-benefit-box-content__info-box--visible', tooltipVisible);

          // Add event listener for click the box
          content.addEventListener('click', function() {
            tooltipVisible = false; // Reset the flag
            content.classList.remove('cust-benefit-box-content__info-box--visible');
          });
        });
      });

      // Use mouseover/mouseout for desktop
      tooltip.forEach(function(tooltip) {
        tooltip.addEventListener('mouseover', function() {
          console.log('mouseover');
          const content = tooltip.closest('[data-js-tooltip-container]').querySelector('[data-js-tooltip-content]');
          content.classList.add('cust-benefit-box-content__info-box--visible');
        });
        tooltip.addEventListener('mouseout', function() {
          console.log('mouseout');
          const content = tooltip.closest('[data-js-tooltip-container]').querySelector('[data-js-tooltip-content]');
          content.classList.remove('cust-benefit-box-content__info-box--visible');
        });
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function() {
    // Initialize the tooltip
    initTooltip();

    // Add event listener for window resize
    window.addEventListener("resize", function() {
      // Re-initialize the tooltip on resize
      initTooltip();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_faq-with-image"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('[data-item]');
    items.forEach(item => {
      item.addEventListener('click', function() {
        this.classList.toggle('active');
        items.forEach(otherItem => {
          if (otherItem !== this) {
            otherItem.classList.remove('active');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["d4-sms-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__iframePopupButtonBound) return;
    window.__iframePopupButtonBound = true;

    function getParts(overlay) {
      return {
        overlay: overlay,
        frame: overlay.querySelector('[data-iframe-popup-frame]')
      };
    }

    function openPopup(overlay, src) {
      var parts = getParts(overlay);
      var nextSrc = src || (parts.frame && parts.frame.dataset.src);
      if (parts.frame && nextSrc && parts.frame.getAttribute('src') !== nextSrc) {
        parts.frame.src = nextSrc;
      }
      overlay.hidden = false;
      document.body.classList.add('overflow-hidden');
    }

    function closePopup(overlay) {
      overlay.hidden = true;
      if (!document.querySelector('.iframe-popup-button__overlay:not([hidden])')) {
        document.body.classList.remove('overflow-hidden');
      }
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-iframe-popup-open]');
      if (openBtn) {
        var sectionRoot = openBtn.closest('.iframe-popup-button-section') || openBtn.closest('[id^="shopify-section-"]');
        var overlay = sectionRoot && sectionRoot.querySelector('[data-iframe-popup-overlay]');
        if (overlay) openPopup(overlay, openBtn.getAttribute('data-iframe-popup-src'));
        return;
      }

      var closeBtn = e.target.closest('[data-iframe-popup-close]');
      if (closeBtn) {
        var closeOverlay = closeBtn.closest('[data-iframe-popup-overlay]');
        if (closeOverlay) closePopup(closeOverlay);
        return;
      }

      if (e.target.matches('[data-iframe-popup-overlay]')) {
        closePopup(e.target);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.iframe-popup-button__overlay:not([hidden])').forEach(closePopup);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ef-section-button-tabs"] && !Shopify.designMode) return;
  try {
    
  if (document.querySelectorAll('.ef-button-tabs--row').length > 0) {
    document.querySelectorAll('.ef-button-tabs--row').forEach(function(elem) {
      elem.querySelectorAll('.ef-section-button-tabs__tab-btn').forEach(function(tab) {

        if (tab.classList.contains('active') == false) {
          var linked_to = tab.getAttribute('data-linked-to');
          if (linked_to == 'section') {
            var target_1 = tab.getAttribute('data-first-section');
            var target_2 = tab.getAttribute('data-second-section');
            var target_3 = tab.getAttribute('data-third-section');
            if (target_1 != '' && document.querySelector(target_1)) document.querySelector(target_1).style.display = 'none';
            if (target_2 != '' && document.querySelector(target_2)) document.querySelector(target_2).style.display = 'none';
            if (target_3 != '' && document.querySelector(target_3)) document.querySelector(target_3).style.display = 'none';
          } else if (linked_to == 'blocks') {
            var block_id = tab.getAttribute('data-block-id');
            if (block_id != '' && document.querySelectorAll('.star_product_block[data-block-id="' + block_id + '"]').length > 0) {
              document.querySelectorAll('.star_product_block[data-block-id="' + block_id + '"]').forEach(function(elem) { elem.style.display = 'none'; });
              if (document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]')) {
                document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').style.display = 'none';
              }
            }
          }
        }

        tab.addEventListener('click', function(e) {
          var parentElem = this.closest('.ef-button-tabs--row');
          var current_target_1 = parentElem.querySelector('.ef-section-button-tabs__tab-btn.active').getAttribute('data-first-section');
          var current_target_2 = parentElem.querySelector('.ef-section-button-tabs__tab-btn.active').getAttribute('data-second-section');
          var current_target_3 = parentElem.querySelector('.ef-section-button-tabs__tab-btn.active').getAttribute('data-third-section');
          if (current_target_1 != '' && document.querySelector(current_target_1)) document.querySelector(current_target_1).style.display = 'none';
          if (current_target_2 != '' && document.querySelector(current_target_2)) document.querySelector(current_target_2).style.display = 'none';
          if (current_target_3 != '' && document.querySelector(current_target_3)) document.querySelector(current_target_3).style.display = 'none';
          parentElem.querySelector('.ef-section-button-tabs__tab-btn.active').classList.remove('active');
          this.classList.add('active');
          var linked_to = this.getAttribute('data-linked-to');
          if (linked_to == 'section') {
            var target_1 = this.getAttribute('data-first-section');
            var target_2 = this.getAttribute('data-second-section');
            var target_3 = this.getAttribute('data-third-section');
            if (target_1 != '' && document.querySelector(target_1)) document.querySelector(target_1).style.display = 'block';
            if (target_2 != '' && document.querySelector(target_2)) document.querySelector(target_2).style.display = 'block';
            if (target_3 != '' && document.querySelector(target_3)) document.querySelector(target_3).style.display = 'block';
          } else if (linked_to == 'blocks') {
            document.querySelectorAll('.star-page-product-multiple-tab-section .star_product_block').forEach(function(elem) {
              elem.style.display = 'none';
            });
            if (document.querySelectorAll('.star-page-product-multiple-tab-section .view_more_wrapper').length > 0) {
              document.querySelectorAll('.star-page-product-multiple-tab-section .view_more_wrapper').forEach(function(elem) {
                elem.style.display = 'none';
              });
            }
            var block_id = this.getAttribute('data-block-id');
            if (block_id != '' && document.querySelectorAll('.star_product_block[data-block-id="' + block_id + '"]').length > 0) {
              document.querySelectorAll('.star_product_block[data-block-id="' + block_id + '"]').forEach(function(elem, index) {
                var products_count = elem.closest('.star-page-product-multiple-tab-section').getAttribute('data-products-count');
                var products_count_m = elem.closest('.star-page-product-multiple-tab-section').getAttribute('data-products-count-m');
                if (window.innerWidth < 750) {
                  if (index < products_count_m) elem.style.display = 'flex';
                } else {
                  if (index < products_count) elem.style.display = 'flex';
                }
              });
              if (document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]')) {
                if (window.innerWidth < 750) {
                  if (!document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').classList.contains('hideMobile'))
                    document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').style.display = 'flex';
                } else {
                  if (!document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').classList.contains('hideDesktop'))
                    document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').style.display = 'flex';
                }
              }
            }
          }
          if (typeof alignProductTitleRow === 'function') alignProductTitleRow();
        });
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m11-bf-grid-section"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(){
        const btn = document.querySelector('.m11-bf-grid__btn');
        const wrapper = document.querySelector('.m11-bf-grid__popup');
        const closeIcon = document.querySelector('.m11-bf-grid__popup .close-icon');
        btn.addEventListener('click', function(){
            wrapper.style.display = 'block';
        });
        closeIcon.addEventListener('click', function(){
            wrapper.style.display = 'none';
        });
        window.addEventListener('click', function(e){
            if(e.target === wrapper && e.target != document.querySelector('.m9-icon-with-popup-inner')){
                wrapper.style.display = 'none';
            }
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oc-customer-service"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__iframePopupButtonBound) return;
    window.__iframePopupButtonBound = true;

    function getParts(overlay) {
      return {
        overlay: overlay,
        frame: overlay.querySelector('[data-iframe-popup-frame]')
      };
    }

    function openPopup(overlay, src) {
      var parts = getParts(overlay);
      var nextSrc = src || (parts.frame && parts.frame.dataset.src);
      if (parts.frame && nextSrc && parts.frame.getAttribute('src') !== nextSrc) {
        parts.frame.src = nextSrc;
      }
      overlay.hidden = false;
      document.body.classList.add('overflow-hidden');
    }

    function closePopup(overlay) {
      overlay.hidden = true;
      if (!document.querySelector('.iframe-popup-button__overlay:not([hidden])')) {
        document.body.classList.remove('overflow-hidden');
      }
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-iframe-popup-open]');
      if (openBtn) {
        var sectionRoot = openBtn.closest('.iframe-popup-button-section') || openBtn.closest('[id^="shopify-section-"]');
        var overlay = sectionRoot && sectionRoot.querySelector('[data-iframe-popup-overlay]');
        if (overlay) openPopup(overlay, openBtn.getAttribute('data-iframe-popup-src'));
        return;
      }

      var closeBtn = e.target.closest('[data-iframe-popup-close]');
      if (closeBtn) {
        var closeOverlay = closeBtn.closest('[data-iframe-popup-overlay]');
        if (closeOverlay) closePopup(closeOverlay);
        return;
      }

      if (e.target.matches('[data-iframe-popup-overlay]')) {
        closePopup(e.target);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.iframe-popup-button__overlay:not([hidden])').forEach(closePopup);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-compare-table"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        if(document.querySelector('.pdp-compare-table-block-subscribe-popup-button')){
            const popupButton = document.querySelector('.pdp-compare-table-block-subscribe-popup-button');
            const popupButtonWrapper = document.querySelector('.pdp-subscribe-popup-container');
            const popupCloseButton = document.querySelector('.pdp-subscribe-popup-close-button');

            popupButton.addEventListener('click', function() {
                popupButtonWrapper.style.display = 'block';
                document.body.classList.add('overflow-hidden');
            });

            popupCloseButton.addEventListener('click', function() {
                popupButtonWrapper.style.display = 'none';
                document.body.classList.remove('overflow-hidden');
            });

            popupButtonWrapper.addEventListener('click', function(e) {
                if(!e.target.classList.contains('pdp-subscribe-popup-content') && !e.target.closest('.pdp-subscribe-popup-content')){
                popupButtonWrapper.style.display = 'none';
                document.body.classList.remove('overflow-hidden');
                }
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-button"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const popupButton = document.querySelector('.popup-button-link');
    const popupButtonWrapper = document.querySelector('.popup-button-wrapper');
    const popupCloseButton = document.querySelector('.popup-close-button');

    popupButton.addEventListener('click', function() {
      popupButtonWrapper.style.display = 'block';
      document.body.classList.add('overflow-hidden');
    });

    popupCloseButton.addEventListener('click', function() {
      popupButtonWrapper.style.display = 'none';
      document.body.classList.remove('overflow-hidden');
    });

    popupButtonWrapper.addEventListener('click', function(e) {
      if(!e.target.classList.contains('popup-button-popup-content') && !e.target.closest('.popup-button-popup-content')){
        popupButtonWrapper.style.display = 'none';
        document.body.classList.remove('overflow-hidden');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-collection-testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.pps-collection-testimonial').forEach(root => {
      let initialized = false;
      function initialize() {
        if (initialized) return;
        root.removeAttribute('data-pps-defer-render');
        root.classList.remove('pps-slider-pending');
        function adjustArrows() {
          root.querySelector('.slider-button-prev').toggleAttribute('disabled', flkty_main.selectedIndex === 0);
          root.querySelector('.slider-button-next').toggleAttribute('disabled', flkty_main.selectedIndex === flkty_main.slides.length - 1);
        }
    try {
    if(window.innerWidth > 749){
      var flkty_main = new Flickity(root.querySelector('.pps-collection-testimonial-text-slider'), {
        prevNextButtons: true,
        pageDots: false,
        watchCSS: true
      });

      root.querySelector('.pps-collection-testimonial-text-slider-wrap .slider-button-prev').onclick = function(){
        root.querySelector('.pps-collection-testimonial-text-slider .flickity-button.previous').click();
        adjustArrows();
      }

      root.querySelector('.pps-collection-testimonial-text-slider-wrap .slider-button-next').onclick = function(){
        root.querySelector('.pps-collection-testimonial-text-slider .flickity-button.next').click();
        adjustArrows();
      }

      var flkty = new Flickity(root.querySelector('.pps-collection-testimonial-nav-slider'), {
        prevNextButtons: false,
        pageDots: true,
        contain: true,
        wrapAround: true,
        watchCSS: true,
        asNavFor: root.querySelector('.pps-collection-testimonial-text-slider'),
        adaptiveHeight: true,
        setGallerySize: false
      });

      flkty.on('ready', function() {
        flkty.reposition();
      });

      flkty.on('change', function(event, index) {
        root.querySelector('.pps-collection-testimonial-nav-slider').classList.add('slide-changed');
        flkty.reposition();
        flkty_main.select(flkty.selectedIndex);
        adjustArrows();
      });
      adjustArrows();
      flkty_main.on('change', function(event, index) {
        flkty.select(flkty_main.selectedIndex);
        adjustArrows();
      });
    }
    else{
      var swiper = new Swiper(root.querySelector('.pps-collection-testimonial-nav-swiper'), {
        spaceBetween: 0,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        centeredSlides: false,
        breakpoints: {
          749: {
            centeredSlides: true,
            loopAdditionalSlides: 30,
          }
        }
      });
       // thumbs: {
       //    swiper: swiper
       //  },
      var swiper2 = new Swiper(root.querySelector('.pps-collection-testimonial-text-swiper'), {
        slidesPerView: 1,
        slidesPerGroup: 1,
        navigation: {
          nextEl: root.querySelector('.pps-collection-testimonial-text-swiper .swiper-button-next'),
          prevEl: root.querySelector('.pps-collection-testimonial-text-swiper .swiper-button-prev'),
        },
       
        scrollbar: {
            el: root.querySelector('.swiper-scrollbar'),
            draggable: true
        }
      });
      swiper.on('slideChange', () => {
        swiper2.slideTo(swiper.activeIndex);
      });
      
      swiper2.on('slideChange', () => {
        swiper.slideTo(swiper2.activeIndex);
      });
    }
        initialized = true;
    } catch (error) {
      [flkty_main, flkty, swiper, swiper2].forEach(function(instance) {
        if (instance && typeof instance.destroy === 'function') instance.destroy();
      });
      throw error;
    }
      }

    if (root.hasAttribute('data-defer-pps-slider') && window.ecoflowPpsInitSlider) {
      window.ecoflowPpsInitSlider(root, initialize);
    } else if (root.hasAttribute('data-defer-pps-slider') && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) start();
      }, { rootMargin: '600px 0px' });
      const start = () => {
        observer.disconnect();
        root.removeEventListener('pointerdown', start, true);
        root.removeEventListener('focusin', start, true);
        initialize();
      };
      root.addEventListener('pointerdown', start, { capture: true, once: true });
      root.addEventListener('focusin', start, { capture: true, once: true });
      observer.observe(root);
    } else {
      initialize();
    }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-users-with-indication"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.pps-users-section').forEach(root => {
        const swiperEl = root.querySelector('.swiper');
        function initialize() {
          if (swiperEl.swiper) return;
          new Swiper(swiperEl, {
            slidesPerView: 'auto',
            navigation: {
              nextEl: root.querySelector('.swiper-button-next'),
              prevEl: root.querySelector('.swiper-button-prev'),
            },
            spaceBetween: 20,
            scrollbar: {
                el: root.querySelector('.swiper-scrollbar'),
                draggable: true
            }
        });
        }

    if (root.hasAttribute('data-defer-pps-slider') && window.ecoflowPpsInitSlider) {
      window.ecoflowPpsInitSlider(root, initialize);
    } else if (root.hasAttribute('data-defer-pps-slider') && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) start();
      }, { rootMargin: '600px 0px' });
      const start = () => {
        observer.disconnect();
        root.removeEventListener('pointerdown', start, true);
        root.removeEventListener('focusin', start, true);
        initialize();
      };
      root.addEventListener('pointerdown', start, { capture: true, once: true });
      root.addEventListener('focusin', start, { capture: true, once: true });
      observer.observe(root);
    } else {
      initialize();
    }
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-users"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
        let swiperEl = document.querySelector('.pps-users-section .swiper');
        new Swiper(swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            scrollbar: {
                el: '.pps-users-section .swiper-scrollbar',
                draggable: true
            }
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cards-pillar-lp"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', (event) => {
    const mobile = window.matchMedia('(max-width: 749px)');
    const roots = document.querySelectorAll('[data-whole-home-product-cards]');
    let observer;
    function update(container) {
      const swiperEl = container.querySelector('.product-cards-wrapper');
      const enabled = container.classList.contains(mobile.matches ? 'mobile-product-cards-slider' : 'product-cards-slider');
      if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
      if (!enabled) return;
      new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: mobile.matches ? 14 : 24,
        pagination: mobile.matches ? { el: swiperEl.querySelector('.swiper-pagination') } : undefined
      });
    }
    function activate(container) {
      if (container.dataset.wholeHomeCardsReady) return;
      update(container);
      container.dataset.wholeHomeCardsReady = 'true';
      if (observer) observer.unobserve(container);
    }
    if (roots.length && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting) activate(entry.target); });
      }, { rootMargin: '400px 0px' });
    }
    roots.forEach(container => {
      if (observer) observer.observe(container);
      else activate(container);
      ['pointerdown', 'focusin', 'keydown', 'click'].forEach(type => {
        container.addEventListener(type, () => activate(container), true);
      });
    });
    if (roots.length) mobile.addEventListener('change', () => {
      roots.forEach(container => { if (container.dataset.wholeHomeCardsReady) update(container); });
    });
    if(window.innerWidth > 749){
        if(document.querySelectorAll('.product-cards-slider:not([data-whole-home-product-cards])').length > 0){
            let swiperContainer = document.querySelectorAll('.product-cards-slider:not([data-whole-home-product-cards])');
            swiperContainer.forEach((container) => {
                let swiperEl = container.querySelector('.product-cards-wrapper');
                new Swiper(swiperEl, {
                    slidesPerView: 'auto',
                    spaceBetween: 24
                });
            });
        }
    }
    if(window.innerWidth <= 749){
        if(document.querySelectorAll('.mobile-product-cards-slider:not([data-whole-home-product-cards])').length > 0){
            let swiperContainer = document.querySelectorAll('.mobile-product-cards-slider:not([data-whole-home-product-cards])');
            swiperContainer.forEach((container) => {
                let swiperEl = container.querySelector('.product-cards-wrapper');
                new Swiper(swiperEl, {
                    slidesPerView: 'auto',
                    spaceBetween: 14,
                    pagination: {
                        el: swiperEl.querySelector(".swiper-pagination"),
                    }
                });
            });
        }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-collection-products"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        if(window.innerWidth < 749){
            if(document.querySelectorAll('.sg-products-section .sg-products-swiper').length > 0){
                document.querySelectorAll('.sg-products-section .sg-products-swiper').forEach(function(swiper){
                    function initialize() {
                        if (swiper.swiper) return;
                        new Swiper(swiper, {
                            slidesPerView: 'auto',
                            pagination: {
                                el: swiper.parentElement.querySelector(".swiper-pagination")
                            },
                        });
                    }
                    var root = swiper.closest('[data-solar-slider]');
                    if (root && window.ecoflowPpsInitSlider) {
                        window.ecoflowPpsInitSlider(root, initialize);
                    } else {
                        initialize();
                    }
                });
            }
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-campaign-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelector('.slider-campaign-terms-popup')) {
      const termsText = document.querySelector('.slider-campaign-section .terms-text');
      const termsPopup = document.querySelector('.slider-campaign-terms-popup');
      const termsPopupClose = document.querySelector('.slider-campaign-terms-popup-close');
      if (termsText) {
        termsText.addEventListener('click', function() {
          termsPopup.style.display = 'block';
        });
      }
      termsPopupClose.addEventListener('click', function() {
        termsPopup.style.display = 'none';
      });
      termsPopup.addEventListener('click', function(e) {
        if (e.target != document.querySelector('.slider-campaign-terms-popup-inner') && !e.target.closest('.slider-campaign-terms-popup-inner')) {
          termsPopup.style.display = 'none';
        }
      });
    }

    if(document.querySelector('[data-subscribe-popup-btn]')) {
      const subscribePopupBtn = document.querySelector('[data-subscribe-popup-btn]');
      subscribePopupBtn.addEventListener('click', function() {
        if(document.querySelector('.email-subscription-popup__trigger-image-wrapper'))
          document.querySelector('.email-subscription-popup__trigger-image-wrapper').click();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-multiple"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelectorAll('.popup-button-link').length > 0){
        const popupButton = document.querySelector('.popup-button-link');
        const popupButtonWrapper = document.querySelector('.popup-button-wrapper.star-multiple-popup-button-wrapper');
        const popupCloseButton = document.querySelector('.popup-close-button');

        if(!popupButtonWrapper) return;
        popupButton.addEventListener('click', function() {
          popupButtonWrapper.style.display = 'block';
          document.body.classList.add('overflow-hidden');
        });

        popupCloseButton.addEventListener('click', function() {
          popupButtonWrapper.style.display = 'none';
          document.body.classList.remove('overflow-hidden');
        });

        popupButtonWrapper.addEventListener('click', function(e) {
          if(!e.target.classList.contains('popup-button-popup-content') && !e.target.closest('.popup-button-popup-content')){
            popupButtonWrapper.style.display = 'none';
            document.body.classList.remove('overflow-hidden');
          }
        });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-page-title"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sectionRoot = document.querySelector('.star-page-title-section');

    if (!sectionRoot) {
      return;
    }

    var sectionWrapper = sectionRoot.parentElement;
    const popupButton = sectionRoot.querySelector('.popup-button-link');
    const popupButtonWrapper = sectionWrapper ? sectionWrapper.querySelector('.popup-button-wrapper') : null;
    const popupCloseButton = popupButtonWrapper ? popupButtonWrapper.querySelector('.popup-close-button') : null;

    const handlePopupOpen = function() {
      popupButtonWrapper.style.display = 'block';
      document.body.classList.add('overflow-hidden');
    };

    const handlePopupClose = function() {
      popupButtonWrapper.style.display = 'none';
      document.body.classList.remove('overflow-hidden');
    };

    const handlePopupWrapperClick = function(e) {
      if (!e.target.classList.contains('popup-button-popup-content') && !e.target.closest('.popup-button-popup-content')) {
        handlePopupClose();
      }
    };

    if (popupButton && popupButtonWrapper && popupCloseButton) {
      popupButton.addEventListener('click', handlePopupOpen);
      popupCloseButton.addEventListener('click', handlePopupClose);
      popupButtonWrapper.addEventListener('click', handlePopupWrapperClick);
    }

    document.querySelectorAll('[data-pw-free-ecoflow-client-check="1"]').forEach(function (root) {
      var hasSession = (function () {
        if (typeof getCookie !== 'function') return false;
        var raw = getCookie('userInfo');
        if (!raw) return false;
        try {
          var parsed = JSON.parse(decodeURIComponent(raw));
          return !!(parsed && parsed.token && String(parsed.token).length > 0);
        } catch (e) { return false; }
      })();

      if (hasSession) {
        root.querySelectorAll('[data-open-password-free-login-popup]').forEach(function (btn) {
          var msg = btn.getAttribute('data-password-free-success-message');
          if (msg && msg.trim()) {
            btn.textContent = msg.trim();
            btn.classList.add('password-free-button-link--logged-in');
          }
          btn.removeAttribute('data-open-password-free-login-popup');
        });
      }
    });

    document.addEventListener('shopify:section:unload', function() {
      if (popupButton && popupButtonWrapper && popupCloseButton) {
        popupButton.removeEventListener('click', handlePopupOpen);
        popupCloseButton.removeEventListener('click', handlePopupClose);
        popupButtonWrapper.removeEventListener('click', handlePopupWrapperClick);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-hss-lp"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
        var video_btns = document.querySelectorAll('.video-play-icon');
        var videoOverlay = document.querySelector('.video__iframe-overlay');
        video_btns.forEach(function (thumbnail) {
        thumbnail.addEventListener('click', function (event) {
            const iframeWrapper = thumbnail.closest('.video-hss-block').querySelector('.video__iframe-wrapper');

            if (iframeWrapper) {
            videoOverlay.innerHTML = iframeWrapper.innerHTML;
            videoOverlay.classList.remove('hidden');
            }
        });
        });

        videoOverlay.addEventListener('click', function (event) {
        if (
            event.target.classList.contains('close-btn') ||
            (event.target.parentElement && event.target.parentElement.classList.contains('close-btn'))
        ) {
            videoOverlay.classList.add('hidden');
            videoOverlay.innerHTML = '';
        }
        });

        let swiperEl = document.querySelector('.videos-hss-section .swiper');
        new Swiper(swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 24,
            scrollbar: {
                el: '.videos-hss-section .swiper-scrollbar',
                draggable: true
            }
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-pillar-section"] && !Shopify.designMode) return;
  try {
    
  function initPillarVideos(section) {
    if (section.dataset.pillarVideosReady) return;
    var video_btns = section.querySelectorAll('.video-play-icon');
    var videoOverlay = section.querySelector('.video__iframe-overlay');
    if (!videoOverlay) return;
    section.dataset.pillarVideosReady = 'true';
    video_btns.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function (event) {
        const iframeWrapper = thumbnail.closest('.video-block').querySelector('.video__iframe-wrapper');
        if (iframeWrapper) {
          videoOverlay.innerHTML = iframeWrapper.innerHTML;
          videoOverlay.classList.remove('hidden');
        }
      });
    });
    videoOverlay.addEventListener('click', function (event) {
      if (
        event.target.classList.contains('close-btn') ||
        (event.target.parentElement && event.target.parentElement.classList.contains('close-btn'))
      ) {
        videoOverlay.classList.add('hidden');
        videoOverlay.innerHTML = '';
      }
    });
    if (window.innerWidth <= 749) {
      var swiperContainer = section.querySelector('.swiper');
      var swiper = new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: section.querySelector('.swiper-pagination'),
          clickable: true
        },
      });
    }
  }

  function initPillarVideoSections(root) {
    if (root.matches && root.matches('.videos-pillar-section')) initPillarVideos(root);
    root.querySelectorAll('.videos-pillar-section').forEach(initPillarVideos);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initPillarVideoSections(document); });
  } else {
    initPillarVideoSections(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initPillarVideoSections(event.target); });

  } catch(e) { console.error(e); }
})();
})();
